import { BusinessServices, Country, IUser } from '@shs-digi-care-monorepo/interfaces';

/**
 * Checks if a user belongs to one of the specified countries.
 *
 * @param user - The user to check, or undefined if no user is available.
 * @param countries - An array of countries to check against.
 * @returns `true` if the user's country is included in the provided countries array, `false` otherwise or if user is undefined.
 */
export function isUserFromCountry(user: IUser | null | undefined, countries: Country[]): boolean {
    return user ? countries.includes(user.country as Country) : false;
}

/**
 * Countries the user holds an active role for within the given stream.
 *
 * Roles without a country cover their whole stream and therefore do not narrow
 * the selection down. Users whose role assignments have not been migrated yet
 * fall back to the single country of their profile. See
 * `docs/features/country-differentiation/country-differentiation.concept.md`.
 */
export function getAssignedCountries(user: IUser | null | undefined, stream: BusinessServices): Country[] {
    if (!user) {
        return [];
    }

    const assigned = (user.userRoles ?? [])
        .filter(({ role }) => role.stream === stream && !!role.country)
        .map(({ role }) => role.country as Country);

    const unique = [...new Set(assigned)];
    if (unique.length > 0) {
        return unique;
    }

    return user.country ? [user.country] : [];
}
